import { render, staticRenderFns } from "./BarChartStacked.vue?vue&type=template&id=56955996&"
import script from "./BarChartStacked.vue?vue&type=script&lang=js&"
export * from "./BarChartStacked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports